import type { U3204Message } from '../U3204Service';

export type U3204ConversationTokenUsage = {
  totalInput: number;
  totalOutput: number;
  /** inputTokens du assistant → id du message user du tour */
  inputTokensByUserMessageId: Map<string, number>;
  /** outputTokens par id message assistant completed */
  outputTokensByAssistantMessageId: Map<string, number>;
};

type U3204TokenUsageMessage = Pick<
  U3204Message,
  'id' | 'role' | 'generationStatus' | 'inputTokens' | 'outputTokens'
>;

export function u3204FormatTokenCount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value);
}

function findPrecedingUserMessageId(
  messages: U3204TokenUsageMessage[],
  assistantIndex: number,
): string | undefined {
  for (let index = assistantIndex - 1; index >= 0; index -= 1) {
    if (messages[index]?.role === 'user') {
      return messages[index].id;
    }
  }
  return undefined;
}

export function u3204ComputeConversationTokenUsage(
  messages: U3204TokenUsageMessage[],
): U3204ConversationTokenUsage {
  let totalInput = 0;
  let totalOutput = 0;
  const inputTokensByUserMessageId = new Map<string, number>();
  const outputTokensByAssistantMessageId = new Map<string, number>();

  messages.forEach((message, index) => {
    if (message.role !== 'assistant' || message.generationStatus !== 'completed') {
      return;
    }

    if (message.inputTokens != null) {
      totalInput += message.inputTokens;
      const userMessageId = findPrecedingUserMessageId(messages, index);
      if (userMessageId) {
        inputTokensByUserMessageId.set(userMessageId, message.inputTokens);
      }
    }

    if (message.outputTokens != null) {
      totalOutput += message.outputTokens;
      outputTokensByAssistantMessageId.set(message.id, message.outputTokens);
    }
  });

  return {
    totalInput,
    totalOutput,
    inputTokensByUserMessageId,
    outputTokensByAssistantMessageId,
  };
}
